import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';


@Injectable()
export class TypeValidationGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const allowedTypes = ['bluegate', 'overStay'];
    const type = route.paramMap.get('type');

    if (allowedTypes.includes(type as string)) {
      return true; // Allow navigation
    } else {
      this.router.navigate(['/404']); // Redirect if not valid
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/type-validation.guard.ts